import Model, { attr, belongsTo } from "@ember-data/model";

export default class LoadBalancerErrorModel extends Model {
  @attr text;

  @belongsTo("load-balancer", { async: false, inverse: "errors" }) loadBalancer;
}
